import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Router } from '@remix-run/router';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ThemeProvider } from '@ds';
import { CustomerPortalAppProvider } from '@cp/core/app';
import { PlatformProvider } from '@cp/core/platform';
import { useUserSettingsStore } from '@/store/user-settings.store';
import { IS_DEV_MODE, USE_DEVTOOLS } from '@/constants/env.constants';
import { queryClient } from '@/queries';
import 'react-toastify/dist/ReactToastify.css';

type AppProps = { router: Router };

export const App = ({ router }: AppProps) => {
  const theme = useUserSettingsStore((state) => state.theme);

  return (
    <PlatformProvider>
      <CustomerPortalAppProvider>
        <ThemeProvider theme={theme}>
          <QueryClientProvider client={queryClient}>
            <RouterProvider router={router} />
            {IS_DEV_MODE && USE_DEVTOOLS && <ReactQueryDevtools buttonPosition="top-left" initialIsOpen={false} />}
            <ToastContainer
              autoClose={2000}
              position="bottom-center"
              closeOnClick={false}
              closeButton={false}
              hideProgressBar
              newestOnTop={false}
              draggable={false}
              pauseOnHover
              toastStyle={{ whiteSpace: 'pre-line' }}
            />
          </QueryClientProvider>
        </ThemeProvider>
      </CustomerPortalAppProvider>
    </PlatformProvider>
  );
};
